import request from '@/utils/request'

export function addCode(data) {
    return request({
        url: '/acode/api/code/add',
        method: 'post',
        data
    })
}

export function updateCode(data) {
    return request({
        url: '/acode/api/code/update',
        method: 'put',
        data
    })
}
export function updateCodeStatus(data) {
    return request({
        url: '/acode/api/code/updateCodeStatus',
        method: 'put',
        data
    })
}
export function deleteCode(params) {
    return request({
        url: '/acode/api/code/delete',
        method: 'delete',
        params
    })
}
export function updateCodeRemark(data) {
    return request({
        url: '/acode/api/code/updateRemark',
        method: 'put',
        data
    })
}

export function getCodeList(data) {
    return request({
        url: '/acode/api/code/list',
        method: 'post',
        data
    })
}
export function updateUserInfo(data) {
    return request({
        url: '/acode/api/admin/updateUserInfo',
        method: 'post',
        data
    })
}
export function codeImport(data) {
    return request({
        url: '/acode/api/code/import',
        method: 'post',
        data
    })
}

export function getCodeDetail(params) {
    return request({
        url: '/acode/api/user/getUserInfo',
        method: 'get',
        params
    })
}


export function exportCode(params) {
    return request({
        url: '/acode/api/code/export',
        method: 'get',
        params
    })
}

export function codeRelease(params) {
    return request({
        url: '/acode/api/code/release',
        method: 'get',
        params
    })
}

export function updateBatch(data) {
    return request({
        url: '/acode/api/code/updateBatch',
        method: 'put',
        data
    })
}

export function codeReleaseBatch(params) {
    return request({
        url: '/acode/api/code/releaseBatch?codeIds=' + params,
        method: 'get'
    })
}